import { EntityTable } from '@/features/admin/EntityTable';

export function EspecialidadesPage() {
  return (
    <EntityTable
      title="Especialidades cirúrgicas"
      subtitle="Cardio, Neuro, Ortopedia etc. — usado para colorir kits no arsenal"
      endpoint="/v1/specialties"
      queryKey="specialties"
      columns={[
        { key: 'code', label: 'Código', className: 'font-mono text-xs' },
        { key: 'name', label: 'Nome' },
        {
          key: 'color_hex', label: 'Cor',
          render: (r: any) =>
            r.color_hex ? (
              <span className="inline-flex items-center gap-2">
                <span className="h-4 w-4 rounded border border-neutral-300" style={{ background: r.color_hex }} />
                <span className="font-mono text-xs">{r.color_hex}</span>
              </span>
            ) : '—',
        },
      ]}
      fields={[
        { name: 'code', label: 'Código', type: 'text', required: true },
        { name: 'name', label: 'Nome', type: 'text', required: true },
        { name: 'color_hex', label: 'Cor (hex)', type: 'text', placeholder: '#0078D4' },
      ]}
    />
  );
}
